import type { GetEventsFilterValueResponse, GetEventsResponse } from "@/modules/events/api/getEvents"
import type { SimpleSelectOption } from "@/modules/layouts/components/MultiSelect/MultiSelect"

function mapFilterValueToSimpleSelectOption(input: GetEventsFilterValueResponse): SimpleSelectOption {
  const {
    label,
    meta: { count },
    value,
  } = input

  return { count, label, value: `${value}` }
}

export function getOptionsAndValuesFromFilters({
  field,
  filters,
  overridenValues,
}: {
  field: string
  filters: GetEventsResponse["meta"]["filters"]
  overridenValues?: string[] | null
}): {
  options: SimpleSelectOption[]
  title: string
  values: SimpleSelectOption[]
} {
  const filterValues = filters.find(({ id }) => id === field)

  if (!filterValues || !filterValues.values.length) {
    return { options: [], title: filterValues?.label || "", values: [] }
  }

  const options = filterValues.values.map(mapFilterValueToSimpleSelectOption)
  const values =
    typeof overridenValues !== "undefined"
      ? filterValues.values
          .filter(({ value }) => (overridenValues || []).includes(`${value}`))
          .map(mapFilterValueToSimpleSelectOption)
      : filterValues.values.filter(({ meta: { selected } }) => !!selected).map(mapFilterValueToSimpleSelectOption)

  return { options, title: filterValues.label, values }
}
